import AxiosProvider from '@/app/utils/api/axios-provider';

export default {
  getLuaRawData(clientId: number, dataSourceName: string, segmentId: string) {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/lua-raw-data?datasourceName=${dataSourceName}&segmentId=${segmentId}`
    );
  },
};
